/**
 * Скрипт для блока Основные даты
 * - Выпадающий список с датами
 * - При скролле страницы дата в списке синхронизируется
 * - При выборе даты — скролл к контенту
 */
document.addEventListener( 'DOMContentLoaded', function() {
	const blocks = document.querySelectorAll( '.block-main-dates' );

	blocks.forEach( function( block ) {
		const yearsSelect = block.querySelector( '.years-select' );
		const datesList = block.querySelector( '.dates-list' );
		const datesItems = datesList ? datesList.querySelectorAll( '.dates-item' ) : [];

		if ( ! yearsSelect || ! datesItems.length ) {
			return;
		}

		let isScrollingToDate = false;
		const isMobile = window.innerWidth <= 768;
		const OFFSET = isMobile ? 100 : 200;
		const wrapper = block.querySelector( '.years-select-wrapper' );

		// Показывать/скрывать плашку в зависимости от видимости блока
		function toggleWrapperVisibility() {
			if ( ! wrapper || ! isMobile ) return;

			const blockRect = block.getBoundingClientRect();
			const blockBottom = blockRect.bottom;
			const viewportHeight = window.innerHeight;

			// Плашка видна, пока низ блока не дошёл до 150px от низа экрана
			if ( blockBottom > viewportHeight - 400 ) {
				wrapper.style.display = '';
			} else {
				wrapper.style.display = 'none';
			}
		}

		// Выбор даты из списка
		yearsSelect.addEventListener( 'change', function() {
			const index = parseInt( yearsSelect.value, 10 );
			const target = datesItems[ index ];
			if ( target ) {
				isScrollingToDate = true;
				const rect = target.getBoundingClientRect();
				const offset = rect.top + window.pageYOffset - OFFSET;
				window.scrollTo( {
					top: offset,
					behavior: 'smooth',
				} );
				// Сбросим флаг через небольшую задержку после завершения скролла
				setTimeout( function() {
					isScrollingToDate = false;
				}, 500 );
			}
		} );

		// Синхронизация выбранной даты при скролле страницы
		function syncSelectOnScroll() {
			if ( isScrollingToDate ) return;
			let currentIndex = 0;
			const scrollPos = window.pageYOffset + OFFSET;
			const blockRect = block.getBoundingClientRect();
			const blockTop = blockRect.top + window.pageYOffset;

			if ( window.pageYOffset < blockTop + 50 ) {
				currentIndex = 0;
			} else {
				let found = false;
				datesItems.forEach( function( item, i ) {
					const itemRect = item.getBoundingClientRect();
					const offsetTop = itemRect.top + window.pageYOffset;
					if ( scrollPos >= offsetTop ) {
						currentIndex = i;
						found = true;
					}
				} );

				if ( ! found ) {
					const viewportBottom = window.pageYOffset + window.innerHeight;
					for ( let i = datesItems.length - 1; i >= 0; i-- ) {
						const itemRect = datesItems[ i ].getBoundingClientRect();
						const offsetTop = itemRect.top + window.pageYOffset;
						if ( offsetTop < viewportBottom ) {
							currentIndex = i;
							break;
						}
					}
				}
			}

			if ( parseInt( yearsSelect.value, 10 ) !== currentIndex ) {
				yearsSelect.value = currentIndex;
			}
		}

		let ticking = false;
		window.addEventListener( 'scroll', function() {
			if ( ! ticking ) {
				window.requestAnimationFrame( function() {
					syncSelectOnScroll();
					toggleWrapperVisibility();
					ticking = false;
				} );
				ticking = true;
			}
		} );

		// Инициализация видимости
		toggleWrapperVisibility();
	} );
} );
